import { createActionGroup, emptyProps } from '@ngrx/store';

export const AccessibilityActions = createActionGroup({
  source: 'Accessibility',
  events: {
    'Toggle high contrast': emptyProps(),
    'Set font size percentage': (fontSizePercentage: number) => ({ fontSizePercentage }),
    'Reset reducer': emptyProps()
  }
});
